module.exports = __webpack_public_path__ + "img/arena.eef10f12.jpeg";